/**
 * 工具提示图标
 */
const ToolTipIcon = ({ width = 16, height = 16, color = '#86868B' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 17 18" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.20004 9.00365C2.20004 5.35857 5.15496 2.40365 8.80004 2.40365C12.4451 2.40365 15.4 5.35857 15.4 9.00365C15.4 12.6487 12.4451 15.6036 8.80004 15.6036C5.15496 15.6036 2.20004 12.6487 2.20004 9.00365ZM8.80004 0.936984C4.34494 0.936984 0.733373 4.54855 0.733372 9.00365C0.733372 13.4587 4.34494 17.0703 8.80004 17.0703C13.2551 17.0703 16.8667 13.4587 16.8667 9.00365C16.8667 4.54855 13.2551 0.936985 8.80004 0.936984ZM9.53324 12.6636L9.53324 8.28882L8.79991 7.58073L8.06657 8.28882L8.06657 12.6636L9.53324 12.6636ZM8.06657 5.33956L8.06657 6.04764L8.79991 6.75573L9.53324 6.04764L9.53324 5.33956L8.06657 5.33956Z"
        fill={color}
      />
    </svg>
  )
}

export default ToolTipIcon
